export default {"src":"/_next/static/media/separate.2e9f11d8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};